// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4f199960","239":"448d64c2","455":"fb3aa66c","488":"dde91bcc","536":"eb506ed4","725":"3bb6e92b","848":"728a7bc1"}[chunkId] + ".chunk.js";
};